module.exports = __webpack_public_path__ + "static/perth-334bb0441f1b8aaf5cda16639f7af5c6.jpg";